jQuery(function ($) {

    // If the mobile menu is open and the page is resized to
    // desktop view (>600px), remove the open menu
	$( window ).on( 'resize', function( e ) {
		if ( jQuery( window ).width() > 600 ) {
            jQuery('body').removeClass('mobile-menu-visible');
        }
    });
    


});

    function openNav() {
        jQuery('body').addClass('mobile-menu-visible');
    }

    function closeNav() {
        jQuery('body').removeClass('mobile-menu-visible');
    }



if (typeof jQuery.mask !== 'undefined' ) {
	console.log(jQuery.mask.definitions['9']);
}